/* Collection-linked PDP adapter migrated from the live Turbo 8.3.0 theme. */
/*============================================================================
  Product
==============================================================================*/
function pdpDebugLog(label, payload) {
  if (!window.__PDP_COLOR_DEBUG__ || typeof console === 'undefined' || !console.debug) return;
  console.debug('[pdp-debug]', label, payload);
}

window.pdpLegacySelectCallback = function (variant, selector, $element) {
  const evt = document.createEvent('HTMLEvents');

  let $product;

  if ($element) {
    $product = $element.find(`.product-${selector.product.id}`);
  } else {
    $product = $(`.product-${selector.product.id}`);
  }

  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');

  const hasCompleteSelectedOptions = hasCompleteVariantSelection($productForm, selector.product);
  const resolvedVariant = getVariantFromSelectedOptions($productForm, selector.product);
  const resolvedMatchesIncoming = !!(resolvedVariant && variant && String(resolvedVariant.id) === String(variant.id));
  const activeVariant = hasCompleteSelectedOptions ? resolvedVariant : variant;
  pdpDebugLog('selectCallback', {
    productId: selector?.product?.id || null,
    incomingVariantId: variant?.id || null,
    resolvedVariantId: resolvedVariant?.id || null,
    resolvedMatchesIncoming,
    hasCompleteSelectedOptions,
    masterValue: selector?.variantIdField?.value || null,
    formVariantId: $productForm.find('select[name="id"], select[data-variants]').first().val() || null
  });
  if (selector.variantIdField) {
    if (activeVariant) {
      selector.variantIdField.disabled = false;
      selector.variantIdField.value = activeVariant.id;
    } else if (hasCompleteSelectedOptions) {
      selector.variantIdField.disabled = true;
    }
  }
  variant = activeVariant;

  // Manually trigger change event so
  // pure JS listeners can receive it
  evt.initEvent('change', false, true);
  if (selector.variantIdField) {
    selector.variantIdField.dispatchEvent(evt);
  }
  document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant, product: selector.product } }));
  document.dispatchEvent(new CustomEvent('product:variant:change', { detail: { variant, product: selector.product } }));

  // Notify form

  const $notifyForm = $(`.notify-form-${selector.product.id}`);
  const productTitle = $notifyForm.data('product-title');
  const $notifyFormInputs = $('.notify_form__inputs', $product);
  const notifySend = window.PXUTheme.translation.notify_email_send;
  const notifyUrl = $notifyFormInputs.data('url');

  // Construct the notify message
  if (variant) {
    if (variant.title !== 'Default Title') {
      // Escape the variant title
      window.variantTitle = variant.title.replace(/"/g, '&quot;');
      window.notifyMessage = window.PXUTheme.translation.notify_message_first + productTitle + ' - ' + window.variantTitle + window.PXUTheme.translation.notify_message_last + notifyUrl;
    } else {
      window.notifyMessage = window.PXUTheme.translation.notify_message_first + productTitle + window.PXUTheme.translation.notify_message_last + notifyUrl;
    }
  }

  // Prefill the email address if a customer is logged in
  let notifyFormEmail;
  let notifyFormPlaceholder;

  if ($notifyForm.hasClass('notify-form--customer')) {
    notifyFormEmail = $notifyForm.data('customer-email');
    notifyFormPlaceholder = '';
  } else {
    notifyFormEmail = '';
    notifyFormPlaceholder = window.PXUTheme.translation.notify_email;
  }

  // Compile HTML
  window.notifyFormHTML = `
    <input
      class="notify-email"
      id="contact[email]"
      name="contact[email]"
      type="email"
      placeholder="${notifyFormPlaceholder}"
      value="${notifyFormEmail}"
      required
    >

    <input
      type="hidden"
      name="challenge"
      value="false"
    >

    <input
      class="notify_form_message"
      name="contact[body]"
      type="hidden"
      data-body="${window.notifyMessage}"
      value="${window.notifyMessage}"
    >

    <input
      class="
        global-button
        global-button--primary
      "
      type="submit"
      value="${notifySend}"
    >
  `;

  // Image Variant feature
  if (variant && variant.featured_image && $product.is(':visible')) {
    const $sliders = $('.js-product-gallery', $product);
    $sliders.each((_, slider) => {
      const $slider = $(slider);
      const $sliderInstance = window.Flickity.data($slider[0]);
      if ($slider && $sliderInstance !== undefined) {
        const index = $slider.find(`[data-image-id="${variant.featured_media.id}"]`).data('index');
        if (index !== undefined) {
          $sliderInstance.select(index, false, true);
        }
      } else if (window.DardanosProductGallery && typeof window.DardanosProductGallery.focusMedia === 'function') {
        window.DardanosProductGallery.focusMedia(variant.featured_media.id, $slider[0]);
      }
    });
  }

  // Toggles images in product slider when inline quickshop and layout set to slider
  if (variant && variant.featured_image && $product.is(':visible')) {
    if (window.PXUTheme.theme_settings.product_form_style === 'select' && window.PXUTheme.theme_settings.quick_shop_style === 'inline') {
      const $selectedVariants = $('.products-slider').find('select option:not(.selector-wrapper select option)').filter(':selected');
      $selectedVariants.each(function toggleImage() {
        if ($(this).data('featured-image')) {
          const swatchImage = $(this).data('image');
          const $quickShopElement = $(this).parents('.thumbnail').find('.image__container img');

          $quickShopElement.attr('src', swatchImage);
          $quickShopElement.attr('srcset', swatchImage);
        }
      });
    }
  }

  if (variant) {
    if (variantInventory) {
      [...variantInventory].forEach(v => {
        if (v.id === variant.id) {
          const currentVariant = variant;
          currentVariant.inventory_quantity = v.inventory_quantity;
          currentVariant.inventory_management = v.inventory_management;
          currentVariant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.sku span', $product).text(variant.sku);

    if (window.PXUTheme.theme_settings.product_form_style === 'radio') {
      const { length } = variant.options;
      for (let i = 0; i < length; i++) {
        const radioButton = $productForm.find(`.swatch[data-option-index="${escape(i)}"] :radio[value="${variant.options[i].replace(/"/g, '\\"')}"]`);
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    } else {
      $('.notify_form_message', $product).attr('value', `${$('.notify_form_message', $product).data('body')} - ${window.variantTitle}`);
    }
  }

  if (variant && variant.available === true) {
    if (variant.inventory_management && variant.inventory_quantity > 0) {
      if (window.PXUTheme.theme_settings.display_inventory_left) {
        if (variant.inventory_quantity === 1) {
          window.itemsLeftText = window.PXUTheme.translation.one_item_left;
        } else {
          window.itemsLeftText = window.PXUTheme.translation.items_left_text;
        }

        const inventoryThreshold = parseInt(window.PXUTheme.theme_settings.inventory_threshold, 10);
        if (variant.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(`${variant.inventory_quantity} ${window.itemsLeftText}`);
        } else {
          $('.items_left', $product).html('');
        }
      }
      if (window.PXUTheme.theme_settings.limit_quantity && variant.inventory_policy === 'deny') {
        $('.quantity', $product).attr('max', variant.inventory_quantity);
      }
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }
  } else {
    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
  }

  syncProductPurchaseState($product, variant);

  if (window.PXUTheme.currency.show_multiple_currencies) {
    window.currencyConverter.convertCurrencies();
  }
};

function syncProductPurchaseState($product, variant) {
  if (!$product || !$product.length) return;

  const $productForm = $('.product_form, .shopify-product-form', $product).first();
  let product;
  try {
    product = $productForm.data('product') || JSON.parse($productForm.attr('data-product') || '{}');
  } catch (error) {
    product = null;
  }

  const hasCompleteSelectedOptions = hasCompleteVariantSelection($productForm, product);
  const selectedVariant = hasCompleteSelectedOptions ? getVariantFromSelectedOptions($productForm, product) : variant;
  const isAvailable = !!(selectedVariant && selectedVariant.available);
  const $notifyForms = $product.find('.notify-form');
  const $notifyFormInputs = $product.find('.notify_form__inputs');
  const soldOutText = window.PXUTheme.translation.sold_out_text || 'Size Unavailable';
  const message = soldOutText;
  const $productSection = $product.closest('.js-product-section, .js-product_section, .product_section, [data-pdp-main]');
  const $visibilityScope = $productSection.length ? $productSection : $product;
  const $fulfillment = $visibilityScope.find('[data-product-fulfillment]');
  const $vipBanner = $visibilityScope.find('.modern-banner.banner-vip');

  pdpDebugLog('syncProductPurchaseState', {
    productId: product?.id || null,
    selectedVariantId: selectedVariant?.id || null,
    selectedVariantAvailable: selectedVariant?.available ?? null,
    selectedVariantOptions: selectedVariant?.options || null,
    resolvedFromArg: !!variant,
    hasCompleteSelectedOptions,
    message
  });

  if (isAvailable) {
    $fulfillment.prop('hidden', false);
    $vipBanner.prop('hidden', false);
    $('.sold_out', $product).text('');
    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span')
      .text($('.add_to_cart', $product).data('label'));
    $('.shopify-payment-button', $product).removeClass('disabled');
    $('.purchase-details__buttons', $product).removeClass('product-is-unavailable');
    $('.modal_price', $product).removeClass('variant-unavailable');
    $notifyForms.hide();
    $notifyFormInputs.empty();
    return;
  }

  $fulfillment.prop('hidden', true);
  $vipBanner.prop('hidden', true);

  if (selectedVariant) {
    $('.modal_price', $product).removeClass('variant-unavailable');
  } else {
    $('.modal_price', $product).addClass('variant-unavailable');
  }

  $('.items_left', $product).text('');
  $('.quantity', $product).removeAttr('max');
  $('.sold_out', $product).text(message);
  $('.purchase-details__buttons', $product).addClass('product-is-unavailable');
  $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span')
    .text(message);
  $('.shopify-payment-button', $product).addClass('disabled');
  $notifyForms.hide();
  $notifyFormInputs.empty();

  if (selectedVariant && !selectedVariant.available) {
    $notifyForms.fadeIn();
    $notifyFormInputs.empty();
    $notifyFormInputs.append(window.notifyFormHTML);
  }
}

function getSelectedOptionValues($productForm, product) {
  const optionValues = [];
  const optionCount = Array.isArray(product?.options) ? product.options.length : 0;

  for (let index = 0; index < optionCount; index += 1) {
    const $swatch = $productForm.find(`.swatch[data-option-index="${index}"]`);
    const $radios = $swatch.find('input[type="radio"]');

    if ($radios.length > 0) {
      if ($radios.length === 1) {
        optionValues[index] = $radios.eq(0).val() || null;
      } else {
        const $checked = $radios.filter(':checked:not([disabled])').first();
        optionValues[index] = $checked.length ? $checked.val() : null;
      }
      continue;
    }

    const $selector = $productForm.find('.single-option-selector').eq(index);
    optionValues[index] = $selector.length ? $selector.val() || null : null;
  }

  return optionValues;
}

function hasCompleteVariantSelection($productForm, product) {
  if (!$productForm || !$productForm.length || !product || !Array.isArray(product.variants)) return false;

  const optionValues = getSelectedOptionValues($productForm, product);
  const optionCount = Array.isArray(product.options) ? product.options.length : 0;
  if (optionValues.length !== optionCount) return false;

  for (let index = 0; index < optionCount; index += 1) {
    if (optionValues[index] == null) return false;
  }

  return true;
}

function getVariantFromSelectedOptions($productForm, product) {
  if (!$productForm || !$productForm.length || !product || !Array.isArray(product.variants)) return null;

  const optionValues = getSelectedOptionValues($productForm, product);
  const optionCount = Array.isArray(product.options) ? product.options.length : 0;

  for (let index = 0; index < optionCount; index += 1) {
    const $swatch = $productForm.find(`.swatch[data-option-index="${index}"]`);
    const $radios = $swatch.find('input[type="radio"]');
    const swatchName = $swatch.attr('data-option-name') || null;
    const radiosState = Array.from($radios).map(radio => ({
      value: radio.value,
      checked: !!radio.checked,
      disabled: !!radio.disabled
    }));
    if ($radios.length > 0) {
      pdpDebugLog('getVariantFromSelectedOptions.option', {
        productId: product?.id || null,
        optionIndex: index,
        swatchName,
        optionValue: optionValues[index],
        radios: radiosState
      });

      continue;
    }

    const $selector = $productForm.find('.single-option-selector').eq(index);

    pdpDebugLog('getVariantFromSelectedOptions.option', {
      productId: product?.id || null,
      optionIndex: index,
      swatchName,
      optionValue: optionValues[index],
      selectorValue: $selector.length ? $selector.val() || null : null,
      radios: radiosState
    });
  }

  const hasMissingOption = (function() {
    if (optionValues.length !== optionCount) return true;
    for (let index = 0; index < optionCount; index += 1) {
      if (optionValues[index] == null) return true;
    }
    return false;
  })();

  if (!optionValues.length || hasMissingOption) {
    pdpDebugLog('getVariantFromSelectedOptions.incomplete', {
      productId: product?.id || null,
      optionValues,
      optionCount
    });
    return null;
  }

  const matchedVariant = product.variants.find(variant => {
    if (!variant || !Array.isArray(variant.options)) return false;
    return optionValues.every((value, index) => String(variant.options[index] || '') === String(value || ''));
  }) || null;

  pdpDebugLog('getVariantFromSelectedOptions', {
    productId: product?.id || null,
    optionValues,
    matchedVariantId: matchedVariant?.id || null,
    matchedVariantAvailable: matchedVariant?.available ?? null
  });

  return matchedVariant;
}

window.pdpLegacyProductPage = {
  loadQuickshop(url) {
    return window.shopifyAsyncview.load(
      url, // Template name
      { view: 'quickshop' }, // View name (suffix)
    );
  },
  // PDP color changes replace the product section in place. Bind Fancybox to the
  // newly inserted gallery links without re-running the complete product setup.
  bindProductGalleryLightbox($scope) {
    const $galleryLinks = $scope && $scope.length
      ? $scope.find('.js-product-gallery a')
      : $('[data-pdp-main] .js-product-gallery a');

    if (!$galleryLinks.length) return;

    if (!$.fancybox) {
      if (window.loadFancybox) {
        window.loadFancybox().then(() => {
          window.pdpLegacyProductPage.bindProductGalleryLightbox($scope);
        });
      }
      return;
    }

    $galleryLinks.fancybox({
      width: 800,
      height: 800,
      baseClass: 'product-section__lightbox',
      clickContent: false,
      arrows: true,
      toolbar: true,
      smallBtn: true,
      infobar: false,
      afterShow(instance) {
        // Loop through fancybox images, add alt attributes
        const fancyImages = $('.fancybox-image');
        $('.product-gallery__image').each((index, image) => {
          const $image = $(image);
          const alt = $image.attr('alt');
          fancyImages.eq(index).attr('alt', alt);
        });

        const zoom = instance.$trigger.first().parents('.js-product-gallery').data('zoom');
        if (zoom) {
          $('.fancybox-image').last()
            .wrap('<span class="zoom-wrap" style="display:inline-block"></span>')
            .css('display', 'block')
            .parent()
            .zoom({
              touch: false,
              magnify: 1,
            });
        }
      },
      afterClose(instance) {
        const $instanceGallery = instance.$trigger.first().parents('.js-product-gallery');
        $instanceGallery.hide();
        setTimeout(() => {
          $instanceGallery.fadeIn(100);
          $('.js-product-gallery').find('.is-selected a').focus();
        }, 1);
      },
    });
  },
  init() {
    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
      },
    ], window.productMedia.setupMedia);

    // Call enable gallery function for product galleries
    $('[data-pdp-main] [data-product-gallery]').each(function () {
      const $productGallery = $(this);
      if ($productGallery.attr('data-desktop-grid-gallery') === 'true') {
        if (window.DardanosProductGallery && typeof window.DardanosProductGallery.initGallery === 'function') {
          window.DardanosProductGallery.initGallery($productGallery[0]);
        }
        return;
      }

      window.pdpLegacyProductPage.enableGallery($productGallery);
    });

    if (window.location.search === '?contact_posted=true') {
      $('.notify-form .contact-form').hide();
      $('.notify-form .contact-form').prev('.message').html(window.PXUTheme.translation.notify_success_text);
    }

    if (window.PXUTheme.theme_settings.product_form_style === 'radio') {
      $('body')
        .off('change.productPageSwatchLogic', '.swatch :radio')
        .on('change.productPageSwatchLogic', '.swatch :radio', function swatchLogic() {
        const optionIndex = $(this).closest('.swatch').attr('data-option-index');
        const optionValue = $(this).val();
        const parentForm = $(this).closest('.product_form form');
        let notifyForm;

        if (parentForm.siblings('.notify-form').length) {
          window.notifyForm = parentForm.siblings('.notify-form');
        } else {
          window.notifyForm = $('.js-notify-form');
        }

        const option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
        const option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
        const option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';
        let notifyMessage;

        if (option1 && option2 && option3) {
          window.notifyMessage = `${option1} / ${option2} / ${option3}`;
        } else if (option1 && option2) {
          window.notifyMessage = `${option1} / ${option2}`;
        } else {
          window.notifyMessage = option1;
        }

        window.notifyForm.find('.notify_form_message').attr('value', `${window.notifyForm.find('.notify_form_message').data('body')} - ${window.notifyMessage}`);

        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');

      });
    }

    this.bindProductGalleryLightbox();

    // Complementary products
    const complementaryProductsEl = document.querySelector('[data-complementary-products]');

    if (complementaryProductsEl) {
      const sectionEl = complementaryProductsEl.closest('.product_section');
      const {
        sectionId,
        productId,
        productRecommendationLimit,
      } = JSON.parse(document.querySelector('[data-complementary-products-data]').textContent);

      this.complementaryProductRecommendations = new ComplementaryProducts({
        sectionEl,
        sectionId,
        productId,
        productRecommendationsRoute: window.PXUTheme.routes.product_recommendations_url,
        includeIndicatorDots: true,
        limit: productRecommendationLimit,
        arrowShape: 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z',
      });
    }

    /*
      If the product recommendations section exists, run the loadProductRecommendations method
      The selectCallback within this method will only affect the products in the product recommendations section
    */
    if (false) {
      window.pdpLegacyProductPage.loadProductRecommendations();
    }
  },
  runOptionSelector($element) {
    let $defaultSelector = $('[data-pdp-main] .js-product-section [data-product-form]');

    if ($element) {
      $defaultSelector = $element.find('[data-product-form]');
    }

    $defaultSelector.each((_, options) => {
      const $options = $(options);
      const $productDetails = $options.closest('.product__details');

      // Set up variables for price ui and surface pickup
      let priceUIEl;

      const paymentTerms = new window.PaymentTerms($productDetails[0]);

      // If smaller screen size and thumbnail hover enabled
      // use price ui element inside of caption instead
      if (window.PXUTheme.media_queries.medium.matches && window.PXUTheme.theme_settings.hover_enabled && window.PXUTheme.theme_settings.quick_shop_enabled && window.PXUTheme.theme_settings.quick_shop_style === 'inline') {
        priceUIEl = $productDetails.find('.modal_price [data-price-ui], .product-info__caption [data-price-ui]')[0];
      } else {
        priceUIEl = $productDetails.find('[data-price-ui]')[0];
      }

      const priceUIBadgeEl = $productDetails.find('[data-price-ui-badge]')[0];
      const surfacePickUpEl = $productDetails.find('[data-surface-pick-up]')[0];
      const JSONData = $options.data('product');
      const isPriceSavingsEnabled = priceUIEl && priceUIEl.closest(['[data-display-savings="true"]']);
      const productTitle = $options.data('product-title');

      let priceUI;
      let priceUIBadge;
      let surfacePickUp;
      let currentVariant;

      if (priceUIEl) {
        priceUI = new window.ShopifyPriceUI.PriceUI(priceUIEl);
      }

      if (priceUIBadgeEl) {
        priceUIBadge = new window.ShopifyPriceUI.PriceUIBadge(priceUIBadgeEl);
      }

      if (surfacePickUpEl) {
        surfacePickUp = new window.ShopifySurfacePickUp(surfacePickUpEl);
        surfacePickUp.onModalRequest(contents => {
          const surfacePickUpModal = document.querySelector('[data-surface-pick-up-modal]');
          let fragment;
          if (currentVariant.title && productTitle) {
            fragment = document.createDocumentFragment();
            const header = document.createElement('div');
            const title = document.createElement('h2');
            header.classList.add('surface-pick-up__modal-header');
            title.classList.add('surface-pick-up__modal-title');
            title.innerHTML = productTitle;
            header.appendChild(title);
            if (currentVariant.title !== 'Default Title') {
              const subtitle = document.createElement('span');
              subtitle.classList.add('surface-pick-up__modal-subtitle');
              subtitle.innerHTML = currentVariant.title;
              header.appendChild(subtitle);
            }
            fragment.appendChild(header);
          }
          surfacePickUpModal.innerHTML = contents;
          surfacePickUpModal.insertBefore(fragment, surfacePickUpModal.firstChild);
          $.fancybox.open(
            surfacePickUpModal,
            {
              hash: false,
              infobar: false,
              toolbar: false,
              loop: true,
              smallBtn: true,
              touch: false,
              video: {
                autoStart: false,
              },
              mobile: {
                preventCaptionOverlap: false,
                toolbar: true,
              },
            },
          );
        });
      }

      new window.Shopify.OptionSelectors($options.data('select-id'), {
        product: $options.data('product'),
        onVariantSelected: (variant, selector) => {
          currentVariant = variant;

          paymentTerms.update(variant ? variant.id : null);

          if (priceUI) {
            priceUI.load(
              JSONData,
              {
                variant,
                formatter: price => window.Shopify.formatMoney(price, $('body').data('money-format')),
                handler: (priceUIFragment, _product, { variant: v }) => {
                  if (isPriceSavingsEnabled && v) {
                    if (v.compare_at_price > v.price) {
                      const span = document.createElement('span');
                      span.classList.add('sale', 'savings');
                      const savings = v.compare_at_price - v.price;
                      const percentage = Math.round((savings / v.compare_at_price) * 100);
                      span.innerHTML = `${window.PXUTheme.translation.savings_text} ${percentage}% (<span class="money">${window.Shopify.formatMoney(v.compare_at_price - v.price, $('body').data('money-format'))}</span>)`;

                      priceUIFragment.appendChild(span);
                    }
                  }

                  if (v && v.available) {
                    if (v.price === 0) {
                      const fragment = document.createDocumentFragment();
                      const span = document.createElement('span');
                      span.classList.add('free-price-text');

                      if (window.PXUTheme.theme_settings.free_text !== '') {
                        span.innerHTML = window.PXUTheme.theme_settings.free_text;
                      } else {
                        span.innerHTML = `<span class="money">${window.Shopify.formatMoney(v.price, $('body').data('money-format'))}</span>`;
                      }

                      fragment.appendChild(span);

                      return fragment;
                    }

                    return priceUIFragment;
                  }

                  if (!window.PXUTheme.theme_settings.display_sold_out_price) {
                    const fragment = document.createDocumentFragment();
                    const soldOutText = document.createElement('span');
                    soldOutText.classList.add('sold_out');
                    soldOutText.innerHTML = v
                      ? window.PXUTheme.translation.sold_out_text
                      : window.PXUTheme.translation.unavailable_text;
                    fragment.appendChild(soldOutText);
                    return fragment;
                  }

                  // Displays sold out text beside price
                  if (window.PXUTheme.theme_settings.display_sold_out_price) {
                    const span = document.createElement('span');

                    span.classList.add('sold_out');
                    span.innerHTML = v
                      ? window.PXUTheme.translation.sold_out_text
                      : window.PXUTheme.translation.unavailable_text;

                    priceUIFragment.appendChild(span);
                  }

                  return priceUIFragment;
                },
              },
            );

            if (window.PXUTheme.theme_settings.display_sold_out_price && variant && variant.price === 0 && !variant.available) {
              const priceElement = priceUIEl.querySelector('[data-price]');
              if (!priceElement) { return; }
              if (window.PXUTheme.theme_settings.free_text !== '') {
                const span = document.createElement('span');
                span.classList.add('free-price-text');
                span.innerHTML = window.PXUTheme.theme_settings.free_text;
                priceElement.innerHTML = '';
                priceElement.appendChild(span);
              } else if (window.PXUTheme.theme_settings.free_text === '') {
                priceElement.classList.add('price--sale');
                return;
              }
            }
          }

          if (priceUIBadge) {
            priceUIBadge.load(
              JSONData,
              {
                variant,
                style: 'default',
                formatter: price => window.Shopify.formatMoney(price, $('body').data('money-format')),
                handler: (priceUIFragment, _product, { variant: v }) => {
                  if (v && v.available) {
                    if (!v.compare_at_price || v.compare_at_price <= v.price) {
                      return document.createDocumentFragment();
                    }

                    return priceUIFragment;
                  }

                  if ((v && !v.available) || !v) {
                    const fragment = document.createDocumentFragment();
                    let text;
                    const sticker = document.createElement('div');
                    sticker.classList.add('price-ui-badge__sticker');
                    const stickerText = document.createElement('span');
                    stickerText.classList.add('price-ui-badge__sticker-text');
                    stickerText.setAttribute('data-badge', '');

                    if (v && !v.available) {
                      sticker.classList.add('price-ui-badge__sticker--sold-out');
                      text = window.PXUTheme.translation.sold_out_text;
                    }

                    if (!v) {
                      sticker.classList.add('price-ui-badge__sticker--unavailable');
                      text = window.PXUTheme.translation.unavailable_text;
                    }

                    stickerText.innerHTML = text;
                    sticker.appendChild(stickerText);
                    fragment.appendChild(sticker);
                    return fragment;
                  }

                  return priceUIFragment;
                },
              },
            );
          }

          // Avoid loading surface pickup for the inline quick shop
          if (surfacePickUp && !$options.closest('.js-product-section').hasClass('inline-quickshop')) {
            surfacePickUp.load(variant ? variant.id : null);
          }

          window.pdpLegacySelectCallback(variant, selector, $element);
        },
        enableHistoryState: $options.data('enable-state'),
      });
    });
  },
  enableGallery(selector) {
    // Variables
    const $productGallery = $(selector);
    const $slides = $productGallery.find('.gallery-cell');
    const $thumbnailProductGallery = $productGallery.closest('.js-product-section').find('.product_gallery_nav');
    const $thumbnails = $thumbnailProductGallery.find('.gallery-cell');
    const zoom = $productGallery.data('zoom');
    const productLightbox = $productGallery.data('product-lightbox');
    const thumbnailsEnabled = $productGallery.data('thumbnails-enabled');
    const thumbnailsSliderEnabled = $productGallery.data('thumbnails-slider-enabled');
    const thumbnailsPosition = $productGallery.data('thumbnails-position');
    const thumbnailsArrows = $productGallery.data('gallery-arrows-enabled');
    const slideshowSpeed = $productGallery.data('slideshow-speed');
    const galleryInstance = window.Flickity.data($productGallery[0]);
    const thumbnailGalleryInstance = $thumbnailProductGallery.length ? window.Flickity.data($thumbnailProductGallery[0]) : undefined;
    const isDesktopGallery = window.innerWidth >= 799;
    const isDesktopGridGallery = isDesktopGallery && $productGallery.attr('data-desktop-grid-gallery') === 'true';

    function destroyLegacyControls() {
      if (galleryInstance !== undefined) {
        try {
          $productGallery.flickity('destroy');
        } catch (_) {}
      }

      if (thumbnailGalleryInstance !== undefined) {
        try {
          $thumbnailProductGallery.flickity('destroy');
        } catch (_) {}
      }

      $productGallery.find('.flickity-prev-next-button, .flickity-page-dots').remove();
      $thumbnailProductGallery.find('.flickity-prev-next-button, .flickity-page-dots').remove();
      $productGallery.removeClass('flickity-enabled');
      $thumbnailProductGallery.removeClass('flickity-enabled');
    }

    // If zoom enabled
    if (zoom === true) {
      if (window.is_touch_device() && window.PXUTheme.media_queries.medium.matches) {
        // Lightbox has a built-in zoom feature, so check if lightbox is disabled
        if (productLightbox === 'false') {
          document.addEventListener('lazybeforeunveil', window.imageFunctions.zoom);
        }
      } else {
        document.addEventListener('lazybeforeunveil', window.imageFunctions.zoom);
      }
    }

    if (isDesktopGridGallery) {
      destroyLegacyControls();

      if (window.DardanosProductGallery && typeof window.DardanosProductGallery.syncGallery === 'function') {
        window.DardanosProductGallery.syncGallery($productGallery[0]);
      }

      return;
    }

    if (window.DardanosProductGallery && window.DardanosProductGallery.isDesktopGrid($productGallery[0])) {
      destroyLegacyControls();
      window.DardanosProductGallery.syncGallery($productGallery[0]);
      return;
    }

    if (galleryInstance !== undefined) {
      return;
    }

    $productGallery.on('ready.flickity', () => {
      $slides.each((index, slide) => {
        // Determine media type
        const mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
        let videoID;

        switch (mediaType) {
          case 'external_video':

            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (window.videoPlayers) {
              window.videoPlayers.forEach(player => {
                const currentPlayer = player;
                if (player.id === videoID || player.media.id === videoID) {
                  if (!$(slide).hasClass('is-selected')) {
                    currentPlayer.keyboard = {
                      focused: false,
                      global: false,
                    };
                  }
                }
              });
            }
            break;
          case 'video':

            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (window.videoPlayers) {
              window.videoPlayers.forEach(player => {
                const currentPlayer = player;
                if (player.id === videoID || player.media.id === videoID) {
                  if (!$(slide).hasClass('is-selected')) {
                    currentPlayer.keyboard = {
                      focused: false,
                      global: false,
                    };
                  }
                }
              });
            }
            break;
          case 'model':
            if ($(slide).hasClass('is-selected')) { // When active slide
              if (mediaType === 'model' && window.isScreenSizeLarge()) {
                $(slide).on('mouseenter', () => {
                  $productGallery.flickity('unbindDrag');
                });
                $(slide).on('mouseleave', () => {
                  $productGallery.flickity('bindDrag');
                });
              }
            }
            break;
          default:
            break;
        }
      });

      // Video looping
      const loopingEnabled = $productGallery.data('video-loop');

      $.each(window.videoPlayers, (index, player) => {
        const videoPlayer = player;
        videoPlayer.loop = loopingEnabled;
      });
    });

    $productGallery.on('change.flickity', () => {
      $slides.each((index, slide) => {
        // Determine media type of current slide
        const mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');

        if ($(slide).hasClass('is-selected')) { // When active slide
          switch (mediaType) {
            case 'model':

              /* On slide change, if active slide contains 3d model
              * If on desktop, on hover, unbind flickity, after hover bind flickity
              * On model play event, unbind flickity to ensure model can be interacted with
              * On model pause event, bind flickity so that slide can be swiped
              * Pause all model slides when hidden
              */

              if (window.isScreenSizeLarge()) {
                // On mouseenter event, unbind flickity
                $(slide).on('mouseenter', () => {
                  $productGallery.flickity('unbindDrag');
                });

                // On mouseleave event, bind flickity
                $(slide).on('mouseleave', () => {
                  $productGallery.flickity('bindDrag');
                });
              }

              // Listen for model pause/play events
              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', () => {
                $productGallery.flickity('unbindDrag');
              });

              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', () => {
                $productGallery.flickity('bindDrag');
              });
              break;
            default:
              $productGallery.flickity('bindDrag');
              break;
          }
        } else {
          // When inactive slide
          switch (mediaType) {
            case 'external_video':
              // Youtube video pausing
              $.each(window.videoPlayers, (_index, player) => {
                player.pause();
              });
              break;
            case 'video':
              // HTML5 video pausing
              $.each(window.videoPlayers, (_index, player) => {
                player.pause();
              });
              break;
            default: break;
          }
        }
      });

      // Restore 3d model icons
      window.productMedia.showModelIcon($productGallery);
    });

    $productGallery.flickity({
      wrapAround: isDesktopGallery,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: !isDesktopGallery && $slides.length > 1,
      prevNextButtons: isDesktopGallery && ($productGallery.data('media-count') > 1 || $slides.length > 1),
      autoPlay: isDesktopGallery ? slideshowSpeed * 1000 : false,
      watchCSS: false,
    });

    // Adjust arrows height if controls are hidden/shown
    $.each(window.videoPlayers, (index, player) => {
      // When controls are hidden, height should be auto
      player.on('controlshidden', () => {
        $productGallery.find('.flickity-prev-next-button').css('height', 'auto');
      });
      // When controls are shown, height should account for controls bar
      player.on('controlsshown', () => {
        $productGallery.find('.flickity-prev-next-button').css('height', 'calc(100% - 64px)');
      });
    });

    function autoplayVideo(videoID, $slide) {
      // Compare id to player object and only play that video
      $.each(window.videoPlayers, (index, player) => {
        if (parseInt(player.media.dataset.plyrVideoId, 10) === videoID) {
          player.play();

          // On fullscreen toggle, focus back on the slide itself
          player.on('exitfullscreen', () => {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    function autoplayYoutubeVideo(iframeID, $slide) {
      // compare id to player object and only play that video
      $.each(window.videoPlayers, (index, player) => {
        if (player.playing) {
          player.pause();
        }

        if (player.media.id === iframeID) {
          player.play();

          // On fullscreen toggle, focus back on the slide itself
          player.on('exitfullscreen', () => {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    function checkForVideos() {
      $slides.each((index, slide) => {
        // Variables
        const $slide = $(slide);
        const mediaType = $slide.data('media-type') || $slide.find('[data-media-type]').data('media-type');
        let videoID = $slide.find('video').data('plyr-video-id');
        const $iframeVideo = $slide.find('iframe');
        const iframeID = $iframeVideo.attr('id');

        if ($slide.hasClass('is-selected')) {
          if (mediaType === 'video') {
            videoID = $slide.find('video').data('plyr-video-id');
            if (videoID) {
              autoplayVideo(videoID, $slide);
            }
          } else if (mediaType === 'external_video' && iframeID) {
            autoplayYoutubeVideo(iframeID, $slide);
          }
        }
      });
    }

    // Checks for videos and plays them if they are the featured media
    // Autoplay logic only happens on desktop, autoplay set to off for mobile
    const $sliderArrows = $productGallery.find('.flickity-prev-next-button');

    if (($sliderArrows || $thumbnails) && window.isScreenSizeLarge()) {
      $sliderArrows.on('click', () => {
        const pId = $productGallery.data('product-id');

        $productGallery.on('settle.flickity', () => {
          // Find out media type of featured media slide
          const $selectedSlide = $productGallery.find('.gallery-cell.is-selected');
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // If model container has class is-selected then play the model
            const sortedModels = [];
            $.each(window.productMedia.models, model => {
              if ($(model.container).closest('.gallery-cell').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });

            $.each(sortedModels, model => {
              const $slide = $(model.container).closest('.gallery-cell');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }
          $productGallery.off('settle.flickity');
        });

        return false;
      });

      $thumbnails.on('click', event => {
        const index = $(event.currentTarget).index();
        const pId = $productGallery.data('product-id');
        $productGallery.flickity('select', index);

        $productGallery.on('settle.flickity', () => {
          // Find out media type of featured media slide
          const $selectedSlide = $productGallery.find('.gallery-cell.is-selected');
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // If model container has class is-selected then play the model
            const sortedModels = [];
            $.each(window.productMedia.models, (_index, model) => {
              if ($(model.container).closest('.gallery-cell').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });

            $.each(sortedModels, (_index, model) => {
              const $slide = $(model.container).closest('.gallery-cell');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }
          $productGallery.off('settle.flickity');
        });
        return false;
      });

      $thumbnails.keypress(event => {
        const index = $(event.currentTarget).index();
        const pId = $productGallery.data('product-id');
        if (event.which === 13) {
          $productGallery.flickity('select', index);

          const $selectedSlide = $productGallery.find('.gallery-cell.is-selected');

          $productGallery.on('settle.flickity', () => {
            $selectedSlide.find('[data-youtube-video]').attr('tabindex', '0');
            $selectedSlide.find('model-viewer, .plyr, a').focus();
            $productGallery.off('settle.flickity');
          });

          // Find out media type of featured media slide
          const mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');

          // Run video autoplay logic if featured media is a video
          if (mediaType === 'video' || mediaType === 'external_video') {
            checkForVideos();
          }

          // Autoplay model if featured media is a model
          if (mediaType === 'model') {
            // If model container has class is-selected then play the model
            const sortedModels = [];
            $.each(window.productMedia.models, model => {
              if ($(model.container).closest('.gallery-cell').data('product-id') === pId) {
                sortedModels.push(model);
              }
            });

            $.each(sortedModels, model => {
              const $slide = $(model.container).closest('.gallery-cell');
              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }
          return false;
        }
        return undefined;
      });
    }

    // Thumbnail gallery logic begins
    if (isDesktopGallery && thumbnailsEnabled === true && thumbnailsSliderEnabled === true && $slides.length > 1) {
      // If desktop determine which slider we build
      // If thumbnail position is left/right then vertical slider gets enabled
      if (thumbnailsPosition === 'left' || thumbnailsPosition === 'right') {
        $thumbnailProductGallery.css('max-height', $productGallery.closest('.product-gallery').outerHeight());
        $thumbnailProductGallery.addClass('vertical-slider-enabled');

        $thumbnails.on('click', event => {
          const index = $(event.currentTarget).index();
          $productGallery.flickity('select', index);
        });

        const navCellHeight = $thumbnails.height();
        const navHeight = $thumbnailProductGallery.height();

        $productGallery.on('select.flickity', () => {
          // set selected nav cell
          const flkty = $productGallery.data('flickity');
          $thumbnailProductGallery.find('.is-nav-selected').removeClass('is-nav-selected');
          const $selected = $thumbnails.eq(flkty.selectedIndex).addClass('is-nav-selected');

          // scroll nav
          const scrollY = $selected.position().top + $thumbnailProductGallery.scrollTop() - (navHeight + navCellHeight) / 2;
          $thumbnailProductGallery.animate({
            scrollTop: scrollY,
          });
        });
      } else {
        $thumbnailProductGallery.flickity({
          cellAlign: 'center',
          contain: true,
          groupCells: '80%',
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: $thumbnails.length > 5 ? thumbnailsArrows : false,
          asNavFor: $productGallery[0],
        });

        $thumbnailProductGallery.on('settle.flickity', () => {
          $thumbnailProductGallery.flickity('resize');
        });

        $(window).on('load', () => {
          $thumbnailProductGallery.flickity('resize');
        });

        // Once thumbnail is focused, move carousel to that cell
        $.each($thumbnails, (index, thumbnail) => {
          const $thumbnail = $(thumbnail);
          if ($thumbnail.hasClass('is-selected')) {
            $thumbnail.on('focus', () => {
              $thumbnailProductGallery.flickity('selectCell', index);
            });
          }
        });
      }
    } else if (!isDesktopGallery && thumbnailGalleryInstance !== undefined) {
      $thumbnailProductGallery.flickity('destroy');
    } else if (thumbnailsEnabled === true) {
      // If thumbnail slider is disabled, ensure thumbnails can still navigate product images
      $thumbnailProductGallery.find('.product-gallery__thumbnail').on('click', function () {
        const index = $(this).index();
        $productGallery.flickity('selectCell', index);
      });
    }

    $(window).on('load', () => {
      $productGallery.flickity().flickity('resize');
    });

    $productGallery.on('settle.flickity', () => {
      $productGallery.flickity().flickity('resize');
    });
  },
  loadProductRecommendations() {
    const $productRecommendations = $('[data-product-recommendations]');
    const $productRecommendationsSection = $('.shopify-section--recommended-products');
    const sectionID = $productRecommendations.data('section-id');
    const productID = $productRecommendations.data('product-id');
    const limit = $productRecommendations.data('limit');
    const recommendationsURL = $productRecommendations.data('recommendations-url');
    const sectionEnabled = $productRecommendationsSection.find($productRecommendations).data('enabled');
    const $recommendedProductSlider = $('.js-recommended-products-slider');

    function loadDynamicProducts() {
      // Build request URL
      const requestUrl = `${recommendationsURL}?section_id=${sectionID}&limit=${limit}&product_id=${productID}`;

      // Make ajax call to request information for window.Shopify's recommended products
      $.ajax({
        type: 'GET',
        url: requestUrl,
        success(data) {
          if (!sectionEnabled) {
            return;
          }

          const $recommendedProductsElement = $(data).find('.product-recommendations').html();

          // Insert product list into the product recommendations container
          $productRecommendations.html($recommendedProductsElement);

          // Initialize product slider if it exists on page
          if ($recommendedProductSlider.length) {
            window.pdpLegacyProductPage.recommendedProductsSlider();
          } else {
            // Call enable gallery function for product galleries
            $('[data-product-recommendations] [data-product-gallery]').each((_, gallery) => {
              const $productGallery = $(gallery);
              window.pdpLegacyProductPage.enableGallery($productGallery);
            });
          }

          // Converting the currencies
          if (window.PXUTheme.currency.show_multiple_currencies) {
            window.currencyConverter.convertCurrencies();
          }

          // Run option selectors
          window.pdpLegacyProductPage.runOptionSelector($productRecommendationsSection);

          // Initialize shopify payment buttons
          if (window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }

          // Hide <noscript> elements
          window.hideNoScript();

          // Initialize video players
          window.videoFeature.setupRecommendedVideoPlayer();

          // Initialize swatch toggler
          $('.swatch_options label').on('click', function() {
            window.quickShop.toggleSwatchImages($(this));
          });

          // Initialize the show secondary media on hover feature
          if (window.PXUTheme.theme_settings.collection_secondary_image) {
            window.imageFunctions.showSecondaryImage();
          }
        },
      });
    }

    if (!sectionEnabled) { return; }

    // If meta collection, no need to run API request
    const metaCollection = $productRecommendations.hasClass('meta-related-recommended-collection');

    if (metaCollection) {
      // Takes care of moving content from Shopify section into block container

      // Initialize product slider if it exists on page
      if ($recommendedProductSlider.length) {
        window.pdpLegacyProductPage.recommendedProductsSlider();
      } else {
        // Call enable gallery function for product galleries
        $('.product-recommendations [data-product-gallery]').each(function () {
          const $productGallery = $(this);
          window.pdpLegacyProductPage.enableGallery($productGallery);
        });
      }

      // Run option selectors
      window.pdpLegacyProductPage.runOptionSelector($productRecommendationsSection);
    } else {
      loadDynamicProducts();
    }
  },
  productSwatches() {
    // Swatches linked with selected options
    if (window.PXUTheme.theme_settings.product_form_style === 'radio') {
      if ($('[data-pdp-main] .js-product-section').length) {
        const $productForms = $('[data-pdp-main] .js-product-section').find('.product_form');

        $productForms.addClass('is-visible');

        // Loop through each product and set the initial option value state

        $productForms.each((_, productForm) => {
          const $productForm = $(productForm);
          const JSONData = $productForm.data('product');
          const productID = $productForm.data('product-id');
          const productSection = `.product-${productID} .js-product-section`;
          const swatchOptions = $productForm.find('.swatch_options .swatch');
          if (swatchOptions.length > 1) {
            window.Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      }

      // Add click event when there is more than one product on the page (eg. Collection in Detail)
      if ($('[data-pdp-main] .js-product-section').length > 1) {
        $('body')
          .off('click.productPageSwatchElement', '.swatch-element')
          .on('click.productPageSwatchElement', '.swatch-element', swatchElement => {
          const $swatchElement = $(swatchElement.currentTarget);
          if ($swatchElement.hasClass('soldout')) {
            return false;
          }
          const swatchValue = $swatchElement.data('value').toString();

          $swatchElement
            .siblings(`input[value="${swatchValue.replace(/"/g, '\\"')}"]`)
            .prop('checked', true)
            .trigger('change');

          const JSONData = $swatchElement.parents('.product_form').data('product');
          const productID = $swatchElement.parents('.product_form').data('product-id');
          const productSection = `.product-${productID} .js-product-section`;
          const swatchOptions = $swatchElement.parents('.product_form').find('.swatch_options .swatch');

          if (swatchOptions.length > 1) {
            window.Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      }
    }
  },
  recommendedProductsSlider() {
    $('.product-recommendations .products-slider').each((_, productSlider) => {
      const $productSlider = $(productSlider);
      const productsPerSlide = $productSlider.data('products-per-slide');
      const productsLimit = $productSlider.data('products-limit');
      const productsAvailable = $productSlider.data('products-available');
      let cellAlign;
      let draggable;
      let prevNext;
      let wrapAround;
      let initialIndex;

      const lessSlidesThanProducts = productsAvailable > productsPerSlide;
      const limitGreaterThanSlide = productsLimit > productsPerSlide;
      const evenSlide = productsPerSlide % 2 === 0;

      if (evenSlide && lessSlidesThanProducts && limitGreaterThanSlide) {
        cellAlign = 'left';
      } else {
        cellAlign = 'center';
      }

      if (lessSlidesThanProducts && limitGreaterThanSlide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (evenSlide && lessSlidesThanProducts && limitGreaterThanSlide) {
        initialIndex = 0;
      } else if (productsPerSlide === '3' && productsAvailable) {
        initialIndex = 1;
      } else if (productsPerSlide === '5' && productsAvailable) {
        initialIndex = 2;
      } else if (productsPerSlide === '7' && productsAvailable) {
        initialIndex = 3;
      }

      if (window.PXUTheme.media_queries.medium.matches) {
        cellAlign = 'center';
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $productSlider.parents('.even-num-slides').removeClass('even-num-slides');
      }

      $productSlider.flickity({
        lazyLoad: 2,
        imagesLoaded: true,
        draggable,
        cellAlign,
        prevNextButtons: prevNext,
        wrapAround,
        contain: true,
        freeScroll: true,
        initialIndex,
      });
    });
  },
  initializeQuantityBox() {
    const syncQuantityButtons = $input => {
      const $box = $input.closest('.product-quantity-box');
      const $minus = $box.find('.product-minus');
      const $plus = $box.find('.product-plus');
      const value = parseInt($input.val(), 10);
      const min = parseInt($input.attr('min'), 10);
      const maxAttr = $input.attr('max');
      const max = maxAttr != null ? parseInt(maxAttr, 10) : null;
      const safeValue = Number.isNaN(value) ? 0 : value;
      const safeMin = Number.isNaN(min) ? 0 : min;

      $minus.toggleClass('is-disabled', safeValue <= safeMin)
        .attr('aria-disabled', safeValue <= safeMin ? 'true' : 'false');

      if (max === null || Number.isNaN(max)) {
        $plus.removeClass('is-disabled').attr('aria-disabled', 'false');
      } else {
        $plus.toggleClass('is-disabled', safeValue >= max)
          .attr('aria-disabled', safeValue >= max ? 'true' : 'false');
      }
    };

    $('.product-quantity-box input').each((_index, input) => {
      syncQuantityButtons($(input));
    });

    $('body')
      .off('click.productQuantityBox', '.js-change-quantity')
      .on('click.productQuantityBox', '.js-change-quantity', e => {
      const $this = $(e.currentTarget);
      const $input = $this.siblings('input');
      const val = parseInt($input.val(), 10);
      const minAttr = parseInt($input.attr('min'), 10);
      const maxAttr = $input.attr('max');
      const valMin = Number.isNaN(minAttr) ? 0 : minAttr;
      const valMax = maxAttr != null ? parseInt(maxAttr, 10) : Number.MAX_SAFE_INTEGER;
      if (isNaN(val) || val < valMin) {
        $input.val(valMin);
      } else if (val > valMax) {
        $input.val(valMax);
      }
      const currentVal = parseInt($input.val(), 10);
      if ($this.data('func') === 'plus') {
        if (currentVal >= valMax) {
          syncQuantityButtons($input);
          return;
        }

        $input.val(currentVal + 1);
      } else {
        if (currentVal <= valMin) {
          syncQuantityButtons($input);
          return;
        }

        $input.val(currentVal - 1);
        if ($this.parents('.cart_item').length) {
          if (currentVal - 1 === 0) {
            $this.closest('.cart_item').addClass('animated fadeOutUp');
          }
        }
      }
      syncQuantityButtons($input);
      $input.trigger('change');
    });
  },
  unload($target) {
    const $slider = $target.find('.products-slider');
    $slider.flickity('destroy');
    $('body').off('click', '.js-change-quantity');
  },
};


/* Initialise only the main PDP after V11's runtime has completed its own setup. */
document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('[data-pdp-main]')) return;

  /*
   * Turbo V11 lazy-loads these vendors. The legacy PDP relies on both, so
   * initialise it only after V11 has supplied the compatible versions.
   */
  Promise.all([
    typeof window.loadFancybox === 'function' ? window.loadFancybox() : Promise.resolve(),
    typeof window.loadFlickity === 'function' ? window.loadFlickity() : Promise.resolve(),
  ]).then(() => {
    window.pdpLegacyProductPage.init();
    window.pdpLegacyProductPage.runOptionSelector();
    window.pdpLegacyProductPage.productSwatches();
  });
});
